// extracted by mini-css-extract-plugin
module.exports = {"pplive":"pplive-1g2TR_Tb","list":"list-3vFcdDke"};